import React, { useEffect, useState } from "react";
import api from '../../../components/api'
import { useEnergiaEletricaGeradaContext } from '../../../context/energiaGeradaContext'
import { onlyNumberWithTwoDecimal, onlyNumberWithDecimal } from '../../../components/functions'
import moment from 'moment'
import { useTabelaGestao } from '../../../context/GestaoPendenciasContext'


const Modal = (props) => {

    const energia_id = props.energia_id
    const adesao_institucional_id = props.adesao_institucional_id
    const ano = props.ano

    const tipoEnergia = 'gerada'
    const { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()

    const { energiaEletricaGerada_id, setEnergiaEletricaGerada_id } = useEnergiaEletricaGeradaContext()

    const [descricaoFatura, setDescricaoFatura] = useState('')
    
    const [tipoSistema, setTipoSistema] = useState('')
    const [tipoConexao, setTipoConexao] = useState('')

    const [fonte, setFonte] = useState('')
    const [potenciaNominal, setPotenciaNominal] = useState('')
    const [fatorPotencia, setFatorPotencia] = useState('')



    const [pontaJan, setPontaJan] = useState('')
    const [foraJan, setForaJan] = useState('')    
    
    const [pontaFev, setPontaFev] = useState('')
    const [foraFev, setForaFev] = useState('')
    
    const [pontaMar, setPontaMar] = useState('')
    const [foraMar, setForaMar] = useState('')
        

    const [pontaAbr, setPontaAbr] = useState('')
    const [foraAbr, setForaAbr] = useState('')

    const [pontaMai, setPontaMai] = useState('')
    const [foraMai, setForaMai] = useState('')
    
    const [pontaJun, setPontaJun] = useState('')
    const [foraJun, setForaJun] = useState('')
    
    const [pontaJul, setPontaJul] = useState('')
    const [foraJul, setForaJul] = useState('')

    const [pontaAgo, setPontaAgo] = useState('')
    const [foraAgo, setForaAgo] = useState('')

    const [pontaSet, setPontaSet] = useState('')
    const [foraSet, setForaSet] = useState('')

    const [pontaOut, setPontaOut] = useState('')
    const [foraOut, setForaOut] = useState('')

    const [pontaNov, setPontaNov] = useState('')
    const [foraNov, setForaNov] = useState('')
    
    const [pontaDez, setPontaDez] = useState('')
    const [foraDez, setForaDez] = useState('')
    



    const handleChange = (e) => {
        e.preventDefault();
    }

    function consultaDadosGeradaDet() {

        //console.log(energiaEletricaGerada_id, '!!?')

        if (energiaEletricaGerada_id) {


            api.get(`energiaEletricaGeradaListaUm/${energiaEletricaGerada_id}`).then((result) => {

                var data = result.data[0]

                setDescricaoFatura(data.descricaoFatura)
                //setConcessionaria(data.concessionaria)
                setTipoSistema(data.tipoSistema)
                setTipoConexao(data.tipoConexao)
                setFonte(data.fonte)
                setPotenciaNominal(data.potenciaNominal)
                setFatorPotencia(data.fatorPotencia)
                

            }).catch((err) => {

                console.log(err.response)

            })


        }


    }



    function apagaEnergiaGerada() {


        if (energiaEletricaGerada_id) {


            window.$.confirm({
                //icon: 'fa fa-question',
                theme: 'material',
                closeIcon: true,
                animation: 'scale',
                type: 'red',
                title: 'Confirmação',
                content: 'Confirma apagar?',
                buttons: {
                    Sim: function () {
    
                        
                        api.delete(`energiaEletricaGerada/${energiaEletricaGerada_id}`).then((result) => {
    
                            //console.log(result.data)
                            //setShow2(false)
                            window.$('#modalEnergiaEletricaGerada').modal('hide')
                            window.toastr.success('Registro salvo com sucesso!')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                            //consultaDadosGerada()
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })
    
                    },
                    Cancelar: function () {
                        //$.alert('Canceled!');
                    }
    
                },
    
            });
    


        }


    }
    

    function salva() {



        if (descricaoFatura == '') {

            //window.toastr.error('<b>Descrição da Fatura</b> não pode ficar em branco!')
            //return false

        }

        



        if (tipoEnergia == 'gerada') {


            if (tipoSistema == '') {

                window.toastr.error('<b>Tipo Sistema</b> não pode ficar em branco!')
                return false
    
            }

            if (tipoConexao == '') {

                window.toastr.error('<b>Tipo de Conexão</b> não pode ficar em branco!')
                return false
    
            }

            if (fonte == '') {

                //window.toastr.error('<b>Fonte</b> não pode ficar em branco!')
                //return false
    
            }

            if (potenciaNominal == '') {

                //window.toastr.error('<b>Potência Nominal (kW)</b> não pode ficar em branco!')
                //return false
    
            } else {

                
                if (parseInt(potenciaNominal) == 0) {

                    //window.toastr.error('<b>Potência Nominal (kW)</b> precisa ser maior que zero!')
                    //return false

                }


            }


            if (fatorPotencia != '') {


                if (parseInt(fatorPotencia) == 0 || parseInt(fatorPotencia) > 100) {

                    //window.toastr.error('<b>Fator de Capacidade (%)</b> não pode ser igual a zero, nem superior a 100!')
                    //return false

                }

                   
            }





            var dataPost = {

                adesao_institucional_id: adesao_institucional_id,
                energia_id: energia_id,
                ano: ano,

                descricaoFatura: descricaoFatura.toUpperCase(),
                
                tipoEnergia: tipoEnergia,
                
                tipoSistema: tipoSistema,
                tipoConexao: tipoConexao,
                fonte: fonte,
                potenciaNominal: potenciaNominal == null ? '' : potenciaNominal.toString(),
                fatorPotencia: fatorPotencia == null ? '' : fatorPotencia.toString(),
                

                pontaJan: pontaJan == null ? '' : pontaJan.toString(),
                foraJan: foraJan == null ? '' : foraJan.toString(),    
                
                pontaFev: pontaFev == null ? '' : pontaFev.toString(),
                foraFev: foraFev == null ? '' : foraFev.toString(),
                
                pontaMar: pontaMar == null ? '' : pontaMar.toString(),
                foraMar: foraMar == null ? '' : foraMar.toString(),
                
                pontaAbr: pontaAbr == null ? '' : pontaAbr.toString(),
                foraAbr: foraAbr == null ? '' : foraAbr.toString(),
                
                pontaMai: pontaMai == null ? '' : pontaMai.toString(),
                foraMai: foraMai == null ? '' : foraMai.toString(),
                
                pontaJun: pontaJun == null ? '' : pontaJun.toString(),
                foraJun: foraJun == null ? '' : foraJun.toString(),
                
                pontaJul: pontaJul == null ? '' : pontaJul.toString(),
                foraJul: foraJul == null ? '' : foraJul.toString(),
                
                pontaAgo: pontaAgo == null ? '' : pontaAgo.toString(),
                foraAgo: foraAgo == null ? '' : foraAgo.toString(),
                
                pontaSet: pontaSet == null ? '' : pontaSet.toString(),
                foraSet: foraSet == null ? '' : foraSet.toString(),
                
                pontaOut: pontaOut == null ? '' : pontaOut.toString(),
                foraOut: foraOut == null ? '' : foraOut.toString(),
                
                pontaNov: pontaNov == null ? '' : pontaNov.toString(),
                foraNov: foraNov == null ? '' : foraNov.toString(),
                
                pontaDez: pontaDez == null ? '' : pontaDez.toString(),
                foraDez: foraDez == null ? '' : foraDez.toString(),
                
                
            }



        }


        
        



        //console.log(dataPost)


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {



                

                    if (tipoEnergia == 'gerada') {

                        if (energiaEletricaGerada_id) {

                            //console.log(dataPost)
                            //return false

                            api.put(`energiaEletricaGerada/${energiaEletricaGerada_id}`, dataPost).then((result) => {

                                //console.log(result.data)
                                //consultaDadosGerada()
                                //setShow2(false)
                                //window.toastr.success('Registro salvo com sucesso!')

                                window.$('#modalEnergiaEletricaGerada').modal('hide')
                                window.toastr.success('Registro salvo com sucesso!')
                                setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
        
                            }).catch((err) => {
        
                                console.log(err.response)
        
                            })



                        } else {

                            

                            api.post(`energiaEletricaGerada`, dataPost).then((result) => {

                                //console.log(result.data)
                                //consultaDadosGerada()
                                //setShow2(false)
                                //window.toastr.success('Registro salvo com sucesso!')

                                window.$('#modalEnergiaEletricaGerada').modal('hide')
                                window.toastr.success('Registro salvo com sucesso!')
                                setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
        
                            }).catch((err) => {
        
                                console.log(err.response)
        
                            })



                        }

                        
                    }


                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }




    function consultaDadosGeradaMensal() {

        if (energiaEletricaGerada_id) {


            api.get(`energiaEletricaGeradaMensalListaUm/${energiaEletricaGerada_id}`).then((result) => {

                console.log(result.data)
                
                var data = result.data[0]

                setPontaJan(data.pontaJan)
                setForaJan(data.foraJan)

                setPontaFev(data.pontaFev)
                setForaFev(data.foraFev)

                setPontaMar(data.pontaMar)
                setForaMar(data.foraMar)

                setPontaAbr(data.pontaAbr)
                setForaAbr(data.foraAbr)

                setPontaMai(data.pontaMai)
                setForaMai(data.foraMai)

                setPontaJun(data.pontaJun)
                setForaJun(data.foraJun)

                setPontaJul(data.pontaJul)
                setForaJul(data.foraJul)

                setPontaAgo(data.pontaAgo)
                setForaAgo(data.foraAgo)

                setPontaSet(data.pontaSet)
                setForaSet(data.foraSet)

                setPontaOut(data.pontaOut)
                setForaOut(data.foraOut)

                setPontaNov(data.pontaNov)
                setForaNov(data.foraNov)

                setPontaDez(data.pontaDez)
                setForaDez(data.foraDez)



            }).catch((err) => {

                console.log(err.response)

            })


        }

    }



    function limpaCampos() {

        
        
        
        setDescricaoFatura('')
        

        setTipoSistema('')
        setTipoConexao('')
        setFonte('')
        setPotenciaNominal('')
        setFatorPotencia('')

        setPontaJan('')
        setForaJan('')    
        
        setPontaFev('')
        setForaFev('')
        

        setPontaMar('')
        setForaMar('')
        

        setPontaAbr('')
        setForaAbr('')
        

        setPontaMai('')
        setForaMai('')
        

        setPontaJun('')
        setForaJun('')
        

        setPontaJul('')
        setForaJul('')
        

        setPontaAgo('')
        setForaAgo('')
        

        setPontaSet('')
        setForaSet('')
        
        setPontaOut('')
        setForaOut('')
        

        setPontaNov('')
        setForaNov('')
        

        setPontaDez('')
        setForaDez('')
        

        


    }





    useEffect(() => {

        limpaCampos()
        consultaDadosGeradaDet()
        consultaDadosGeradaMensal()

    }, [energiaEletricaGerada_id])

    return (

        <div>

            <div className="modal fade" id="modalEnergiaEletricaGerada" tabindex="-1" role="dialog" aria-hidden="true" data-focus="true" >
                    <div className="modal-dialog modal-lg" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Energia Elétrica Gerada</h1>
                            </div>
                            <div className="modal-body">


                                <div className="row">


                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                            
                                            <label className="control-label">Identifição do Sistema</label>
                                            <input type="text" className="form-control"  value={descricaoFatura} onChange={event => setDescricaoFatura(event.target.value)} style={{ textTransform: 'uppercase'}} />
                                                
                                                
                                        </div>
                                    </div>
                                

                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                            
                                            <label className="control-label">Tipo Sistema *</label>
                                            <select class="form-control" value={tipoSistema} onChange={event => setTipoSistema(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                <option value="Geração Distribuída">Geração Distribuída</option>
                                            </select>
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">Tipo de Conexão *</label>
                                            <select class="form-control" value={tipoConexao} onChange={event => setTipoConexao(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                
                                                <option value="Conectado à Rede (On-grid)">Conectado à Rede (On-grid)</option>
                                            </select>
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">Fonte *</label>
                                            <select class="form-control" value={fonte} onChange={event => setFonte(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                <option value="Solar">Solar</option>
                                                <option value="Eólica">Eólica</option>
                                                <option value="Hidráulica">Hidráulica</option>
                                                <option value="Biomassa">Biomassa</option>
                                                <option value="Cogeração Qualificada">Cogeração Qualificada</option>
                                                
                                            </select>
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">

                                                <span class="wrapper2">
                                                    Potência Nominal (kW) *
                                                    <div class="tooltip">
                                                    insira a potência nominal de corrente alternada (CA) que totaliza a potência de saída dos inversores.
                                                    </div>
                                                </span>

                                            </label>


                                            <input type="text" class="form-control" value={potenciaNominal} onChange={event => setPotenciaNominal(event.target.value)} placeholder="0,00"
                                            onKeyPress={(e)=>onlyNumberWithTwoDecimal(e)}
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            />
                                            
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">

                                                <span class="wrapper2">
                                                    Fator de Capacidade (%)
                                                    <div class="tooltip">
                                                    insira o fator de capacidade médio anual (opcional).
                                                    </div>
                                                </span>

                                            </label>

                                            
                                            <input class="form-control" value={fatorPotencia} onChange={event => setFatorPotencia(event.target.value)} placeholder="0,00"
                                            onKeyPress={(e)=>onlyNumberWithTwoDecimal(e)}
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            />                                           
                                                
                                        </div>
                                    </div>

                                    
                                </div>
                                <div className="row">

                                    <div className="col-md-12" >

                                        <table width="100%" className="table table-bordered table-striped table-hover">

                                            <tbody>
                                                <tr>
                                                    <th style={{backgroundColor: '#e6f7ec'}}>
                                                        <center>
                                                        Posto Tarifário
                                                        </center>

                                                    </th>
                                                    <th style={{backgroundColor: '#e6f7ec'}}>

                                                        Ponta/Único

                                                    </th>
                                                    <th style={{backgroundColor: '#e6f7ec'}}>

                                                        Fora de Ponta

                                                    </th>
                                                    

                                                </tr>

                                                <tr>
                                                    
                                                        <td>
                                                            <center>
                                                            Janeiro
                                                            </center>
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={pontaJan} onChange={event => setPontaJan(event.target.value)} 
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                            
                                                        </td>
                                                        <td>
                                                        
                                                            <input className='form-control' value={foraJan} onChange={event => setForaJan(event.target.value)} 
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            
                                                            />
                                                            
                                                            
                                                        </td>
                                                    
                                                    </tr>

                                                    <tr>
                                                    
                                                        <td>
                                                            <center>
                                                            Fevereiro
                                                            </center>
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={pontaFev} onChange={event => setPontaFev(event.target.value)}
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                        </td>
                                                        <td>
                                                            
                                                            <input className='form-control' value={foraFev} onChange={event => setForaFev(event.target.value)} 
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                        </td>
                                                    
                                                    </tr>

                                                    <tr>
                                                    
                                                        <td>
                                                            <center>
                                                            Março
                                                            </center>
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={pontaMar} onChange={event => setPontaMar(event.target.value)} 
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}                                                            
                                                            />
                                                        </td>
                                                        <td>
                                                            
                                                            <input className='form-control' value={foraMar} onChange={event => setForaMar(event.target.value)} 
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                        </td>
                                                    
                                                    </tr>

                                                    <tr>
                                                    
                                                        <td>
                                                            <center>
                                                            Abril
                                                            </center>
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={pontaAbr} onChange={event => setPontaAbr(event.target.value)} />
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={foraAbr} onChange={event => setForaAbr(event.target.value)} />
                                                        </td>
                                                    
                                                    </tr>

                                                    <tr>
                                                    
                                                        <td>
                                                            <center>
                                                            Maio
                                                            </center>
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={pontaMai} onChange={event => setPontaMai(event.target.value)} 
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={foraMai} onChange={event => setForaMai(event.target.value)} 
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                            
                                                        </td>
                                                    
                                                    </tr>

                                                    <tr>
                                                    
                                                        <td>
                                                            <center>
                                                            Junho
                                                            </center>
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={pontaJun} onChange={event => setPontaJun(event.target.value)}
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={foraJun} onChange={event => setForaJun(event.target.value)} 
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                        </td>
                                                    
                                                    </tr>

                                                    <tr>
                                                    
                                                        <td>
                                                            <center>
                                                            Julho
                                                            </center>
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={pontaJul} onChange={event => setPontaJul(event.target.value)} 
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={foraJul} onChange={event => setForaJul(event.target.value)} 
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                        </td>
                                                    
                                                    </tr>

                                                    <tr>
                                                    
                                                        <td>
                                                            <center>
                                                            Agosto
                                                            </center>
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={pontaAgo} onChange={event => setPontaAgo(event.target.value)} 
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={foraAgo} onChange={event => setForaAgo(event.target.value)} 
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                        </td>
                                                    
                                                    </tr>
                                                    <tr>
                                                    
                                                        <td>
                                                            <center>
                                                            Setembro
                                                            </center>
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={pontaSet} onChange={event => setPontaSet(event.target.value)}
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={foraSet} onChange={event => setForaSet(event.target.value)} 
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                        </td>
                                                    
                                                    </tr>
                                                    <tr>
                                                    
                                                        <td>
                                                            <center>
                                                            Outubro
                                                            </center>
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={pontaOut} onChange={event => setPontaOut(event.target.value)} 
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={foraOut} onChange={event => setForaOut(event.target.value)} 
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                        </td>
                                                    
                                                    </tr>
                                                    <tr>
                                                    
                                                        <td>
                                                            <center>
                                                            Novembro
                                                            </center>
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={pontaNov} onChange={event => setPontaNov(event.target.value)} 
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={foraNov} onChange={event => setForaNov(event.target.value)} 
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                        </td>
                                                    
                                                    </tr>
                                                    <tr>
                                                    
                                                        <td>
                                                            <center>
                                                            Dezembro
                                                            </center>
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={pontaDez} onChange={event => setPontaDez(event.target.value)}
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input className='form-control' value={foraDez} onChange={event => setForaDez(event.target.value)} 
                                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                            onCut={handleChange}
                                                            onCopy={handleChange}
                                                            onPaste={handleChange}
                                                            />
                                                        </td>
                                                    
                                                    </tr>

                                            </tbody>

                                        </table>

                                    </div>

                                </div>
                                        

                            </div>
                            <div className="modal-footer">

                                <button type="button" className="btn btn-danger" onClick={() => apagaEnergiaGerada()} style={{ display: energiaEletricaGerada_id ? 'table-row' : 'none'}}>Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salva()}>Salvar</button>
                                
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>

    )

}


export default Modal